import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyLoad from 'vue-lazyload'

// 使用element的slider组件
import { Slider } from 'element-ui'
Vue.use(Slider)
import { Popover } from 'element-ui'
Vue.use(Popover)

Vue.use(VueLazyLoad, {
  preLoad: 1,
  error: require('./assets/img_holder.png'),
  loading: require('./assets/img_holder.png'),
  attempt: 2,
})

import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'

Vue.prototype.$layer = layer(Vue)

import './axios/axios.config'
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
